/* unplugin-vue-components disabled */import script from "./Tab1.vue?vue&type=script&setup=true&lang=js"
export * from "./Tab1.vue?vue&type=script&setup=true&lang=js"

import "./Tab1.vue?vue&type=style&index=0&id=ee125a58&lang=scss&rel=stylesheet%2Fscss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee125a58"]])

export default __exports__